import { styled } from '@mui/material/styles';

import StrapiImage from '@/components/StrapiImage/StrapiImage';

export const PersonWrapper = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  alignItems: 'stretch',
}));

export const CompanyLogo = styled('div')(({ theme }) => ({
  boxSizing: 'content-box',
  width: 42,
  height: 42,
  borderRadius: 2,
  border: `1px solid ${theme.palette.grayscale[300]}`,
  position: 'relative',
}));

export const Logo = styled(StrapiImage)(() => ({
  objectFit: 'contain',
  objectPosition: 'center',
}));
